import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';

export default function OdemeHata() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('orderId');
  const errorMsg = searchParams.get('errorMsg');
  const errorCode = searchParams.get('errorCode');
  const displayMessage = errorMsg || 'İşlem başarısız veya iptal edildi.';

  return (
    <section className="py-5">
      <div className="container text-center">
        <h2 className="mb-3">Ödeme Tamamlanamadı</h2>
        <p className="text-danger mb-2">{displayMessage}</p>
        {errorCode && <p className="small text-muted mb-1">Hata kodu: {errorCode}</p>}
        {orderId && <p className="small text-muted">Sipariş no: {orderId}</p>}
        <Link to="/kayit-ol" className="btn btn-primary mt-3">Kayıt Sayfasına Dön</Link>
      </div>
    </section>
  );
}
